/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetBoostConfigRequest} from '@cash-web/protos/squareup/franklin/app/boost_config.pb'
import {GetBoostConfigResponse} from '@cash-web/protos/squareup/franklin/app/boost_config.pb'


export const getBoostConfigDirect = (request: GetBoostConfigRequest, options?: CashRequestOptions) => post<GetBoostConfigRequest, GetBoostConfigResponse>("/2.0/cash/get-boost-config", request, {...options, rejectOnError: true })